import { ContactPhoneRow } from "services/api/contacts/types";
import { Badge } from "ui/components/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";



export const CONTACT_PHONE_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handlePhoneClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    phone: string
  ) => void,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleWhatsAppClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    phone: string
  ) => void,
  handleViberClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    phone: string
  ) => void,
): Column[] => {

return [
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
 
        return (
          <TableIcon imageUrl="/media/images/phone-icon.svg"  />
        );
      },
    },
    {
      title: t("admin.contact.phone.search.phonenumber"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
        return (
          <>
            <div className="text-md">
              {row.phoneNumber}
            </div>
           
          </>
        );
      },
    },
    {
      title: t("admin.contact.phone.search.description"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
        return (
         <div className="text-md">
            {row.description}
          </div>
        );
      },
    },
    {
      title: t("admin.contact.phone.search.phonetype"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
        return (
         <div className="text-md">
            {row.phoneTypeId === "M" ? t("admin.contact.phone.search.phonetype.mobile") : t("admin.contact.phone.search.phonetype.phone")}
          </div>
        );
      },
    },
    {
      title: t("admin.contact.phone.search.primary"),
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <Badge text={row.primary ? "DA" : "NE"} variant={row.primary ? "success" : "danger"} />
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/phone.svg"
              onClick={(e) => handlePhoneClick(e, row.id)}
            >
              {t("admin.contact.phone.search.call")} ({row.phoneNumber})
            </ButtonMenuItem>
            {row.phoneTypeId === "M" && (
              <>
                <ButtonMenuItem
                  startIcon="/media/icons/whatsapp.svg"
                  onClick={(e) => handleWhatsAppClick(e, row.phoneNumber)}
                >
                   {t("admin.contact.phone.search.sendwhatsapp")}
                </ButtonMenuItem>
                <ButtonMenuItem
                  startIcon="/media/icons/viber.svg"
                  onClick={(e) => handleViberClick(e, row.phoneNumber)}
                >
                   {t("admin.contact.phone.search.sendviber")}
                </ButtonMenuItem>
              </>
            )}
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => handleDeleteClick(e, row.id)}
            >
                 {t("admin.contact.phone.search.remove")}
            </ButtonMenuItem>

          </ButtonMenu>
        );
      },
    },
  ];
};

//   return [
//     {
//       title: "Broj telefona",
//       field: "",
//       type: ColumnTypes.custom,
//       render: (row: ContactPhoneRow) => {
//         return (
//           <div className="max-w-md flex items-center gap-1">
//             <div className="relative group">
//               <button
//                 type="button"
//                 onClick={(e) => handlePhoneClick(e, row.phoneNumber)}
//                 className="inline-flex items-center text-sm font-medium rounded-md px-2 bg-blue-50 border border-blue-600 text-blue-600 cursor-pointer hover:bg-blue-100 transition-colors duration-200"
//               >
//                 {row.phoneNumber}
//               </button>
//               <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
//                 Nazovi {row.phoneNumber}
//               </span>
//             </div>
//             {row.phoneTypeId === "M" && (
//               <>
//                 <div className="relative group">
//                   <button
//                     type="button"
//                     onClick={(e) => handleWhatsAppClick(e, row.phoneNumber)}
//                     className="p-1 rounded hover:bg-green-600 transition-colors duration-200"
//                   >
//                     <ReactSVG
//                       src="/media/icons/whatsapp.svg"
//                       className="w-5 h-5 text-green-500 group-hover:text-white transition-colors duration-200"
//                     />
//                   </button>
//                   <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
//                     Pošalji WhatsApp poruku na {row.phoneNumber}
//                   </span>
//                 </div>
//                 <div className="relative group">
//                   <button
//                     type="button"
//                     onClick={(e) => handleViberClick(e, row.phoneNumber)}
//                     className="p-1 rounded hover:bg-purple-600 transition-colors duration-200"
//                   >
//                     <ReactSVG
//                       src="/media/icons/viber.svg"
//                       className="w-5 h-5 text-purple-500 group-hover:text-white transition-colors duration-200"
//                     />
//                   </button>
//                   <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
//                     Pošalji Viber poruku na {row.phoneNumber}
//                   </span>
//                 </div>
//               </>
//             )}

//           </div>

//         );
//       },
//     },
//     {
//       title: "Primarni",
//       field: "",
//       type: ColumnTypes.custom,
//       render: (row) => {
//         return (
//           <Badge text={row.primary ? "DA" : "NE"} variant={row.primary ? "success" : "danger"} />
//         );
//       },
//     },
//     {
//       title: "",
//       field: "",
//       type: ColumnTypes.custom,
//       render: (row: ContactPhoneRow) => {
//         return (
//           <ButtonMenu
//             endIcon="/media/icons/more-dots.svg"
//             cssClassName="h-full"
//             variant="text"
//           >
//             <ButtonMenuItem
//               startIcon="/media/icons/trash.svg"
//               onClick={(e) => handleDeleteClick(e, row.id)}
//             >
//               Obriši
//             </ButtonMenuItem>

//           </ButtonMenu>
//         );
//       },
//     },
//   ];
// };
